const appColorStyles = {
  primary: '#012640',
  secondary: '#2C4C7D',
  fieldFontColor: '#66A8CA',
}

export default appColorStyles
